import { EndangeredAreaRasters, KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes, LandslideRasters } from "../../../../../../contexts/krFormContext";
import { RastersAttributes } from "../../../../../../contexts/poFormContext";
import { RasterType } from "../../../types/krFormView";

export const appendAttributes = (attributes: LandslideRasters[] | EndangeredAreaRasters[] | undefined, rasterType?: RasterType | undefined, isMap?: boolean) => {
    const data: RastersAttributes[] = [];
    attributes?.forEach((element) => {
        if (element.details) element.details.nameRodzaj = getName(element.details!);
        if (isMap && (element.details?.rodzaj === "mapa_u" || element.details?.rodzaj === "szkic" || element.details?.rodzaj === "mapa_a")) {
            data.push(element.details!);
        } else {
            if (element.details?.rodzaj === rasterType) data.push(element.details!);
        }
    });
    data?.sort((a, b) => a.kolejnosc! - b.kolejnosc!);
    return data;
}

export const getName = (data: RastersAttributes) => {
    if (data.rodzaj === "mapa_u") return "Mapa użytkownika";
    if (data.rodzaj === "mapa_a") return "Mapa z analizy";
    if (data.rodzaj === "szkic") return "Szkic";
    return "";
}

export const appendRasters = (krForm: krFormTypes, isLandslide: boolean, response: any[]) => {
    let oldRasters = isLandslide ? structuredClone((krForm as KrLandslideFormTypes).landslideRasters) : structuredClone((krForm as KrEndangeredAreaFormTypes).endangeredAreaRasters);
    oldRasters = oldRasters
        ?.sort((a, b) => a.details?.kolejnosc! - b.details?.kolejnosc!)
        ?.map((d, index) => {
            return { ...d, details: { ...d.details, kolejnosc: index } }
        });
    const prevCount = oldRasters ? oldRasters.length : 0;
    const newRasters = response.map((element: any, index: number) => {
        return { ...element, details: { ...element.details, kolejnosc: index + prevCount } };
    });
    return oldRasters ? oldRasters.concat(newRasters) : newRasters;
}

export const _changeDescription = (row: any, rasters: LandslideRasters[] | EndangeredAreaRasters[] | undefined) => {
    return rasters?.map((current: any) => ({
        ...current,
        details: {
            ...current.details,
            opis: current.details.globalid === row.globalid ? row.propozycjaOpisu : current.details.opis
        }
    }))
}

export const getMaxKolejnosc = (krForm: krFormTypes, isLandslide: boolean) => {
    let nextIdx = 1;
    const rasters = isLandslide ? (krForm as KrLandslideFormTypes).landslideRasters : (krForm as KrEndangeredAreaFormTypes).endangeredAreaRasters;

    if (rasters && rasters.length > 0) {
        nextIdx = rasters.length + 1;
    }
    rasters?.forEach(r => {
        if (r.details?.kolejnosc) {
            if (r.details.kolejnosc >= nextIdx) {
                nextIdx = r.details.kolejnosc + 1;
            }
        }
    });
    return nextIdx;
}

export const getMaxRasterKolejnosc = (attributes?: RastersAttributes[]) => {
    let nextIdx = 1;
    if (attributes && attributes.length > 0) {
        nextIdx = attributes.length + 1;
    }
    attributes?.forEach(r => {
        if (r.kolejnosc) {
            if (r.kolejnosc >= nextIdx) {
                nextIdx = r.kolejnosc + 1;
            }
        }
    });
    return nextIdx;
}
